// Copyright (c) 2016 Deere & Company

import laborAdditive from './labor-additive';
import openPips from './open-pips';
import pipCodeRequest from './pip-code-request';
import pipDetails from './pip-details';
import pipSearch from './pip-search';
import pips from './pips';
import reports from './reports';

export default {
    ...pips,
    childRoutes: [
        laborAdditive,
        openPips,
        pipCodeRequest,
        pipDetails,
        pipSearch,
        reports
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/pips/open-pips')
    }
};



// WEBPACK FOOTER //
// ./src/routes/pips/index.js